export default "<div class=\"card p-0 d-block col-12\">\n  <div class=\"col-12 p-0\">\n\n  </div>\n</div>"